import { FC, useEffect } from 'react';
import { Outlet } from 'react-router';
import Card from 'components/Card';
import { useStorageData } from 'hooks/useStorageData';
import ProgressBar from 'modules/Transfer/components/ProgressBar';
import { useBrokerList, useTransferInfo } from 'modules/Transfer/hooks';
import store, { TRANSFER_BROKER_MODE_KEY } from '../../store';
import { FormMode } from '../../type';

export const StepLayout: FC = () => {
    const storageDataContext = useStorageData();

    // 提前请求数据
    useBrokerList({ getAllBroker: true });
    useTransferInfo();

    // 每次刷新的话需要从缓存中读取当前是新建模式还是编辑模式
    useEffect(() => {
        const brokerModeCache = sessionStorage.getItem(TRANSFER_BROKER_MODE_KEY) as FormMode | null;

        store.setBrokerMode(brokerModeCache || 'create');
    }, []);

    return (
        <div>
            <Card form>
                <ProgressBar />
            </Card>
            <Outlet context={storageDataContext} />
        </div>
    );
};

export { default as Broker } from './Broker';
export { default as Check } from './Check';
export { default as ChooseTransferType } from './ChooseTransferType';
export { default as Preview } from './Preview';
export { default as Result } from './Result';
export { default as PartialDetails } from './PartialDetails';
